import { Message } from 'element-ui';

let messageInstance = null;

const MESSAGE_TYPES = ['error', 'success', 'info', 'warning'];

const closeCurrentMessage = () => {
  if (messageInstance) {
    messageInstance.close();
  }
};

const showMessage = (options) => {
  closeCurrentMessage();
  messageInstance = Message(options);
  return messageInstance;
};

const createTypedMessageFunction = (type) => {
  return (options = {}) => {
    if (typeof options === 'string') {
      options = { message: options };
    } else {
      options = { ...options };
    }
    options['type'] = type;
    return showMessage(options);
  };
};

const resetMessage = (options) => {
  return showMessage(options);
};

MESSAGE_TYPES.forEach(type => {
  resetMessage[type] = createTypedMessageFunction(type);
});

export default resetMessage;